import React from 'react';

const iconSizes = {
    xxs: '10',
    xs: '12',
    sm: '14',
    md: '16',
    lg: '20',
    xl: '24',
    xxl: '28',
    '3xl': '32',
    '4xl': '40',
    '5xl': '48'
};
const SvgIcon = ({ size = 'md', viewBox, ariaHidden = true, ariaLabel, className, children, focusable = false, ...passThrough }) => {
    const width = iconSizes[size];
    const height = iconSizes[size];
    const SvgProps = {
        viewBox: viewBox,
        'aria-label': ariaLabel,
        'aria-hidden': ariaHidden,
        className: `tw-fill-current${className ? ` ${className}` : ''}`,
        height: `${height}px`,
        width: `${width}px`,
        focusable: focusable
    };
    return (React.createElement("svg", { role: "img", ...SvgProps, ...passThrough }, children));
};

export { SvgIcon };
//# sourceMappingURL=SvgIcon.esm.js.map
